module.exports = __webpack_public_path__ + "d13d35d3d5e06a940cf4d73c5dcfacaa.png";